import React from 'react';
import { Message } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import '../stylesheets/utilities.css';

/**
 * This component renders an error message rendered in a
 * Semantic UI Message component.
 *
 * @param props object
 */
const ErrorMessage = (props) => {
  const { action, message } = props;
  return (
    <div className="re is-flex is-marginTop-16px is-flex-align-center">
      <div className={`re is-flexGrow-1${action ? ' is-marginRight-8px' : ''}`}>
        <Message error>{ message }</Message>
      </div>
      { action
          && (
            <div>
              { action }
            </div>
          )}
    </div>
  );
};

ErrorMessage.propTypes = {
  action: PropTypes.node,
  message: PropTypes.string.isRequired,
};

ErrorMessage.defaultProps = {
  action: undefined,
};

export default ErrorMessage;
